import React from "react";
import "./tabs.scss";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import TabUnstyled from "@mui/base/TabUnstyled";

export interface Tab {
  title: string;
  children?: React.ReactNode;
}

interface classNames {
  container?: string;
  listContainer?: string;
  list?: string;
  listItem?: string;
  listItemText?: string;
  tabPanel?: string;
}

export type TabsProps = {
  tabs: Tab[];
  classNames?: classNames;
};

const CustomTab = (props) => {
  const { ownerState, ...other } = props;
  return <div {...other}>{props.children}</div>;
};

export function Tabs({ tabs, classNames }: TabsProps) {
  return (
    <TabsUnstyled className={classNames?.container ?? "tabs"} defaultValue={0}>
      <div className={classNames?.listContainer ?? ""}>
        <TabsListUnstyled className={classNames?.list ?? "tabs__list"}>
          {tabs?.map((tab, index) => (
            <TabUnstyled
              component={CustomTab}
              key={index}
              className={classNames?.listItem ?? "tabs__list"}
            >
              <div className={classNames?.listItemText ?? ""}>{tab.title}</div>
            </TabUnstyled>
          ))}
        </TabsListUnstyled>
      </div>
      {tabs?.map((tab, index) => (
        <TabPanelUnstyled
          value={index}
          className={classNames?.tabPanel ?? ""}
          key={index}
        >
          {tab.children}
        </TabPanelUnstyled>
      ))}
    </TabsUnstyled>
  );
}
